import { CircleButton } from "../../../../components/elements/CircleButton";
import { animationDurationToShowQuestion } from "../../../../config";
import { motion } from "framer-motion";
import '../../../style.css'


export const TopPart = ({state, firstNumber, secondNumber, result, animate}) => {
    return(
        <div
            className={`bg-[url('/backGrounds/rapid_bg.svg')] bg-cover flex overflow-hidden justify-center items-center rapidWidth border-[3px] rounded-[16px] border-[#85B054] bg-[#FFF] lg:rounded-[20px] px-2 xs:px-0
            ${state ? "toppartIsStateHeight" : "toppartIsNotStateHeight"}`}
        >
           <div className={`text-[#7648B5] flex justify-between items-center text-[28px] w-[267px] h-[39px] font-bigfatScript
                            ${state ? "md:w-[265px] md:h-[39px] md:text-[32px] lg:w-[338px] lg:h-[50px] lg:text-[40px] xl:w-[486px] xl:h-[70px] xl:text-[60px]" : 
                                      "md:w-[376px] md:h-[49px] md:text-[34px] lg:w-[479px] lg:h-[69px] lg:text-[50px]  xl:w-[557px] xl:h-[89px] xl:text-[60px]"
                            }`
                          }
            >
                <motion.div
                    animate={{y: [animate.shift() || 0, 0]}}
                    transition={{duration: animationDurationToShowQuestion , type: "tween", ease: "linear"}}
                >
                   {firstNumber}
                </motion.div>
                <motion.div
                    animate={{y: [animate.shift() || 0, 0]}}
                    transition={{duration: animationDurationToShowQuestion , type: "tween", ease: "linear"}}
                    className="text-[#FFB43B]"
                >
                  x
                </motion.div>
                <motion.div
                    animate={{y: [animate.shift() || 0, 0]}}
                    transition={{duration: animationDurationToShowQuestion , type: "tween", ease: "linear"}}
                >
                   {secondNumber}
                </motion.div>
                <motion.div
                    animate={{y: [animate.shift() || 0, 0]}}
                    transition={{duration: animationDurationToShowQuestion , type: "tween", ease: "linear"}}
                    className="text-[#FFB43B]"
                >
                  =
                </motion.div>
                <motion.div
                    animate={{y: [animate.shift() || 0, 0]}}
                    transition={{duration: animationDurationToShowQuestion , type: "tween", ease: "linear"}}
                >
                    <CircleButton className={"addingresult"} isActive={isNaN(result) ? false : result}>
                        <div className="adding">
                            {result}
                        </div>
                    </CircleButton>
                </motion.div>

           </div>
        </div>
    )
}